
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"m14 1.5 2 2m0 0-2 2m2-2H2V9M4 15.5l-2-2m0 0 2-2m-2 2h14V8"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linejoin":"round","d":"M11.5 7h-5v3h5z"}})])
          )
        }
      }
    